import { filetypeinfo } from 'magic-bytes.js';
import mime from 'mime';

const mimeCache = new WeakMap<File, Promise<string>>();

export function getFileMime(file: File): Promise<string> {
  let result = mimeCache.get(file);

  if (!result) {
    result = file
      .slice(0, 8192)
      .arrayBuffer()
      .then((buffer) => {
        const candidates = new Set(
          filetypeinfo(new Uint8Array(buffer)).flatMap((info) =>
            info.mime ? [info.mime.toLowerCase()] : [],
          ),
        );
        const [candidate] = candidates;
        return candidates.size === 1 && candidate
          ? candidate
          : file.type.toLowerCase();
      });
    mimeCache.set(file, result);
  }

  return result;
}

export function matchesFileType(fileMime: string, accept: string): boolean {
  if (!fileMime) return false;

  return accept.split(',').some((entry) => {
    const value = entry.trim().toLowerCase();
    const allowedMime = value.startsWith('.') ? mime.getType(value) : value;

    if (!allowedMime) return false;
    if (allowedMime === '*' || allowedMime === '*/*') return true;
    if (allowedMime.endsWith('/*')) {
      return fileMime.startsWith(allowedMime.slice(0, -1));
    }
    return fileMime === allowedMime;
  });
}
